import type { Step } from "./surveySteps";

export const CURRENT_ONBOARDING_VERSION = "2026-07";
export const ONBOARDING_VERSION_STEP_ID = "onboardingVersion";

export const LOCAL_ONBOARDING_STEPS: Step[] = [
  {
    id: "fullName",
    question_text: "Tu nombre completo",
    description: "Cuéntanos quién eres",
    type: "text",
    next_step: "mobelNumber",
    required: true,
    isSummary: false,
    survey_id: "default",
    is_first_step: true,
  },
  {
    id: "mobelNumber",
    question_text: "WhatsApp",
    description: "Elige tu indicativo y escribe un número válido.",
    type: "phone",
    next_step: "businessModel",
    required: true,
    isSummary: false,
    survey_id: "default",
    is_first_step: false,
  },
  {
    id: "businessModel",
    question_text: "¿Cuál es tu modelo de negocio?",
    description: "Elige el que mejor describe cómo vendes.",
    type: "single",
    options: [
      {
        label: "Dropshipping",
        description: "Vendo productos sin manejar inventario",
        value: "dropshipping",
        next: "sellingTime",
      },
      {
        label: "Ecommerce",
        description: "Tienda online de productos que importo o comercializo",
        value: "ecommerce",
        next: "sellingTime",
      },
      {
        label: "Marca propia",
        description: "Tengo mi propio producto o lo fabrico",
        value: "own_brand",
        next: "sellingTime",
      },
    ],
    next_step: "sellingTime",
    required: true,
    isSummary: false,
    survey_id: "default",
    is_first_step: false,
  },
  {
    id: "sellingTime",
    question_text: "¿Hace cuánto vendes?",
    description: "Esto nos ayuda a personalizar tu experiencia en Fluxi.",
    type: "single",
    options: [
      {
        label: "Estoy empezando",
        description: "De 0 a 6 meses vendiendo",
        value: "starting",
        next: "productSold",
      },
      {
        label: "Estoy escalando",
        description: "Más de 6 meses y hasta 1 año",
        value: "scaling",
        next: "productSold",
      },
      {
        label: "Modo power",
        description: "Más de 2 años vendiendo",
        value: "power",
        next: "productSold",
      },
    ],
    next_step: "productSold",
    required: true,
    isSummary: false,
    survey_id: "default",
    is_first_step: false,
  },
  {
    id: "productSold",
    question_text: "¿Qué producto vendes?",
    description: "Cuéntanos brevemente cuál es tu producto principal.",
    type: "text",
    next_step: "monthlySales",
    required: true,
    isSummary: false,
    survey_id: "default",
    is_first_step: false,
  },
  {
    id: "monthlySales",
    question_text: "¿Cuánto vendes aproximadamente al mes?",
    description: "",
    type: "single",
    options: [
      { label: "Menos de USD 1,000", value: "under_1000", next: "summary" },
      { label: "USD 1,000 - USD 5,000", value: "1000_5000", next: "summary" },
      { label: "USD 5,000 - USD 10,000", value: "5000_10000", next: "summary" },
      { label: "USD 10,000 - USD 50,000", value: "10000_50000", next: "summary" },
      { label: "USD 50,000 - USD 250,000", value: "50000_250000", next: "summary" },
      { label: "Más de USD 250,000", value: "over_250000", next: "summary" },
    ],
    next_step: "summary",
    required: true,
    isSummary: false,
    survey_id: "default",
    is_first_step: false,
  },
  {
    id: "summary",
    question_text: "Todo listo",
    description: "",
    type: "summary",
    next_step: undefined,
    required: false,
    isSummary: true,
    survey_id: "default",
    is_first_step: false,
  },
];
